var React = require('react');

function IconComment (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M14.6 11.3c.6-1.1.9-2.4.9-3.6 0-4.2-3.4-7.6-7.6-7.6h-.1C6.5.1 5.2.5 4 1.2.4 3.3-.8 8 1.4 11.6c1 1.8 2.7 3 4.7 3.5.6.2 1.2.2 1.9.2 1.2 0 2.5-.3 3.6-.9l3 .8c.3.1.5 0 .7-.2s.3-.5.2-.7l-.9-3zM11.4 10h-7c-.4 0-.7-.4-.7-.8s.3-.8.8-.8h7c.4 0 .8.3.8.8-.1.4-.5.8-.9.8zm0-3h-7c-.4 0-.7-.4-.7-.8s.3-.8.8-.8h7c.4 0 .8.3.8.8-.1.4-.5.8-.9.8z"}));
}

IconComment.defaultProps = {"viewBox":"0 0 16 16","width":"16","height":"16"};

module.exports = IconComment;

IconComment.default = IconComment;
